import React from 'react';
import { usePopup } from '../context/PopupContext';

const NetfluencePopup = () => {
  const { isPopupVisible, hidePopup } = usePopup();
  
  if (!isPopupVisible) return null;
  
  return (
    <div className="fixed bottom-5 right-5 bg-white rounded-lg shadow-lg p-4 max-w-sm z-50 border-2 border-primary-500 animate-fade-in">
      <button 
        onClick={hidePopup}
        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700" 
        aria-label="Close"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
      
      <div className="flex items-center mb-3">
        <div className="w-10 h-10 flex-shrink-0 mr-3">
          <img 
            src="/bearz_logo.png"
            alt="Logo"
            className="w-full h-full object-contain"
          />
        </div>
        <h3 className="text-lg font-bold text-gray-800">Want a Website Like This?</h3>
      </div>
      
      <p className="text-gray-600 mb-4">
        This website was designed and developed by Netfluence. Contact us to create your own professional website!
      </p>
      
      <a 
        href="https://netfluence.ca" 
        target="_blank" 
        rel="noopener noreferrer"
        className="block w-full bg-primary-600 hover:bg-primary-500 text-white text-center font-medium py-2 px-4 rounded transition-colors duration-200"
      >
        Visit Netfluence
      </a>
    </div>
  );
};

export default NetfluencePopup; 